import { render, staticRenderFns } from "./Taxes.vue?vue&type=template&id=2bdfd5d8&scoped=true"
import script from "./Taxes.vue?vue&type=script&lang=js"
export * from "./Taxes.vue?vue&type=script&lang=js"
import style0 from "./Taxes.vue?vue&type=style&index=0&id=2bdfd5d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdfd5d8",
  null
  
)

export default component.exports